<template>
    <div class="add-rule__footer" style="margin-top: 400px;">
        <div class="" v-if="item.id && (user.access_rights.is_owner || user.is_chef ||  user.is_tech_writer)">
            <div class="add-rule__info" v-if="historyLast.date">
                <tooltip
                        :direction="'top-left-direction'"
                        :add-class-wrap="'tooltip-log'"
                        :isBtnClose="false"
                        :add-style="{width: 460 + 'px'}"
                        @tooltipshow="logActive = true"
                        @tooltipclose="logActive = false">
                            <span slot="tooltipBtn" class="i i-info mr4" :class="{active: logActive}">
                            </span>

                    <div slot="tooltipContent">
                        <div class="text-size-s text-bold">
                            История
                        </div>
                        <div class="mt8" v-for="row in history">
                            <span>{{ row.date }}, {{ row.time }}</span>
                            <span class="text-color-grey ml8 mr8">|</span>
                            <span>{{ row.event }}</span>
                            <span class="ml8 mr8 text-color-grey">|</span>
                            <span>{{ row.user }}</span>
                            <span class="ml8 i i-notify" v-if="row.notify"></span>
                            <span class="ml8 i i-notify-mute i--dark-trans" v-else></span>
                        </div>
                    </div>
                </tooltip>
                <span>{{ historyLast.date }}, {{ historyLast.time }}</span>
                <span class="text-color-grey ml8 mr8">|</span>
                <span>{{ historyLast.event }}</span>
                <span class="ml8 mr8 text-color-grey">|</span>
                <span>{{ historyLast.user }}</span>
                <span class="ml8 i i-notify" v-if="historyLast.notify"></span>
                <span class="ml8 i i-notify-mute i--dark-trans" v-else></span>
                <span class="ml8 mr8 text-color-grey">|</span>
                <!-- Технический писатель -->
                <div class="df" v-if="user.is_chef || user.is_tech_writer || user.access_rights.is_owner">
                    <span class="i i-tech-writer i--dark-trans mr4"></span>
                    <span v-if="user.is_tech_writer && !user.is_chef && !user.access_rights.is_owner"><span v-if="techRule">{{ techRule.name }} {{ techRule.lastName }}</span><span v-else>Не назначен...</span></span>
                    <div v-else class="tech-writer-select" :class="{'link': user.access_rights.is_owner ||  user.is_chef}">
                        <input-select-new @change="setTech" :tag="'div'" :options="techOptions" :placeholder="'Не назначен...'" v-model="techWriter" :list-style="{'max-height': 'none'}"></input-select-new>
                    </div>
                    <span class="ml8 mr8 text-color-grey">|</span>
                </div>

                <!-- Шеф-редактор -->
                <div class="df" >
                    <span class="i i-chief i--dark-trans mr4"></span>
                    <span v-if="chefRule">{{ chefRule.name }} {{ chefRule.lastName }}</span>
                    <span v-else>Не назначен...</span>
                    <span class="ml8 mr8 text-color-grey">|</span>
                </div>
                <span>Символов: {{ stripHtml(item.text).length }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Tooltip from '@/components/Tooltip.vue';
import InputSelectNew from '@/components/forms/InputSelectNew.vue';
export default {
    name: "RuleHistory",
    components:{
        Tooltip,
        InputSelectNew
    },
    props: {
        item: {
            default(){
                return {}
            }
        }
    },
    mounted() {
        this.$nextTick(()=>{
            if(this.item.userTechWriterID){
                this.techWriter = this.item.userTechWriterID;
            }
        })
    },
    data(){
        return {
            logActive: false,
            techWriter: false,
        }
    },
    computed: {
        ...mapState({
            user: state => state.users.user,
            tech: state => state.users.tech,
            chef: state => state.users.chef,
        }),
        history() {
            let history = [];

            if (typeof this.item.history !== 'undefined') {
                history = this.item.history;
            }

            return history;
        },
        historyLast() {
            let history = [];

            if (typeof this.item.history !== 'undefined' && this.item.history.length) {
                history = this.item.history.slice(-1).pop();
            }

            return history;
        },
        chefRule(){
            if(this.item.userChefID){
                return this.chef[this.item.userChefID]
            }
        },
        techRule(){
            if(this.item.userTechWriterID){
                return this.tech[this.item.userTechWriterID]
            } else {
                return false
            }
        },
        techOptions(){
            let res = [];
            for(let i in this.tech){
                res.push({id:this.tech[i].id, name: this.tech[i].name + ' '+ this.tech[i].lastName})
            }
            return res
        }
    },
    methods: {
        stripHtml(html)
        {
            let tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        },
        setTech(value){
            this.$store.dispatch('rules/setRuleTech', {user: value,id:this.item.id})
        }
    }
}
</script>

<style scoped>

</style>
